import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import SEO from '../../components/seo';
import PageHeader from '../../components/pageHeader';
import Tabs from '../../components/tab';
import NIcon from '../../assets/img/icon/nesine-icon.svg';
import AyIcon from '../../assets/img/icon/ay-icon.svg';
import NesineLogo from '../../assets/img/logo/nesine-logo.svg';
import AyLogo from '../../assets/img/logo/atyarisi-logo.svg';
import LiderFormLogo from '../../assets/img/logo/liderform-logo.svg';
import TotemLogo from '../../assets/img/logo/totem-logo.svg';
import DownloadIcon from '../../assets/img/icon/download-icon.svg';
import FacebookIcon from '../../assets/img/icon/social/facebook.svg';
import LinkedinIcon from '../../assets/img/icon/social/linkedin.svg';
import WebIcon from '../../assets/img/icon/social/web.svg';
import XIcon from '../../assets/img/icon/social/x.svg';
import YoutubeIcon from '../../assets/img/icon/social/youtube.svg';
import InstagramIcon from '../../assets/img/icon/social/instagram.svg';
import TiktokIcon from '../../assets/img/icon/social/tiktok.svg';
import AppStore from '../../assets/img/icon/stores/app-store.svg';
import PlayStore from '../../assets/img/icon/stores/play-store.svg';
import HuaweiGallery from '../../assets/img/icon/stores/huawei-app-gallery.svg';
import NesineQR from '../../assets/img/qr/nesine-qr.png';
import AyQR from '../../assets/img/qr/ay-qr.png';
import LiderFormQR from '../../assets/img/qr/liderform-qr.jpg';
import Style from './style.module.scss';

const Companies = () => {
  const { t } = useTranslation();

  const nesineTabText = t('companiesPage.companies.nesine', { returnObjects: true });
  const nesineServicesText = t('companiesPage.services.nesine', { returnObjects: true });
  const atyarisiTabText = t('companiesPage.companies.atyarisi', { returnObjects: true });
  const atyarisiServicesText = t('companiesPage.services.atyarisi', { returnObjects: true });
  const liderFormTabText = t('companiesPage.companies.liderform', { returnObjects: true });

  const getMobilePlatform = () => {
    if (typeof window === 'undefined') return 'other';

    const ua = navigator.userAgent.toLowerCase();

    if (ua.includes('iphone') || ua.includes('ipad') || ua.includes('ipod')) {
      return 'ios';
    }

    if (ua.includes('huawei') || ua.includes('huaweibrowser')) {
      return 'huawei';
    }

    if (ua.includes('android')) {
      return 'android';
    }

    return 'other';
  };

  const platform = getMobilePlatform();

  const dataLayerPush = (site) => {
    window.dataLayer.push({
      event: 'GAEvent',
      EventCategory: 'logo_indir',
      EventLabel: site,
      EventAction: 'click',
    });
  };
  const tabs = [
    {
      key: 'nesine',
      label: 'Nesine',
      content: (
        <>
          <section className={Style.section}>
            <div className={Style.container}>
              <div className={Style.companyDetail}>
                <div className={Style.companyText}>
                  <h2 className={Style.companyName}>Nesine</h2>
                  <div className={Style.companyInfo}>
                    {Object.values(nesineTabText).map((text, index) => (
                      <p key={index}>{t(text)}</p>
                    ))}
                  </div>
                </div>
                <div className={Style.companyAttachments}>
                  <a
                    href="https://www.nesine.com/hakkimizda/sirketimiz"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className={clsx(Style.logo, Style.yellowBg)}>
                      <img src={NesineLogo} alt={'Nesine Logo'} />
                    </div>
                  </a>
                  <div className={Style.documentsWrapper}>
                    <a
                      className={Style.document}
                      href="./assets/docs/d-elektronik-27001-2024-Rev04.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={DownloadIcon} alt="download-icon" />
                      {t('companiesPage.iso27001Docs')}
                    </a>
                    <a
                      className={Style.document}
                      href={'./assets/docs/Nesine-LogoBrand.pdf'}
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => {
                        dataLayerPush('NESİNE');
                      }}
                    >
                      <img src={DownloadIcon} alt="download-icon" />
                      LOGO
                    </a>
                  </div>
                  <div className={Style.socialWrapper}>
                    <h4 className={Style.socialTitle}>{t('companiesPage.followUs')}</h4>
                    <div className={Style.linksWrapper}>
                      <a
                        href="https://www.nesine.com"
                        className={Style.link}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={WebIcon} alt="web-icon" />
                        nesine.com
                      </a>
                      <a
                        href="https://www.instagram.com/nesine_com"
                        className={Style.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={InstagramIcon} alt="instagram-icon" />
                        nesine_com
                      </a>
                      <a
                        href="https://www.facebook.com/Nesine"
                        className={Style.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={FacebookIcon} alt="facebook-icon" />
                        Nesine.com
                      </a>
                      <a
                        href="https://x.com/Nesinecom"
                        className={Style.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={XIcon} alt="x-icon" />
                        Nesinecom
                      </a>
                      <a
                        href="https://www.youtube.com/@NesineTV"
                        className={Style.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={YoutubeIcon} alt="youtube-icon" />
                        NesineTV
                      </a>
                      <a
                        href="https://www.linkedin.com/company/nesine"
                        className={Style.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={LinkedinIcon} alt="linkedin-icon" />
                        Nesine
                      </a>
                    </div>
                  </div>
                  <div className={Style.appWrapper}>
                    <h4 className={Style.appTitle}>{t('companiesPage.downloadApps')}</h4>
                    <div className={Style.downloadOptions}>
                      <a href="https://www.nesine.com/indir" target="_blank" rel="noreferrer">
                        <img src={NesineQR} alt="nesine-uygulama-indir" className={Style.qrImg} />
                      </a>
                      <div className={Style.appList}>
                        {platform === 'ios' && (
                          <a
                            href="https://apps.apple.com/tr/app/nesine-i-ddaa/id534981561"
                            target="_blank"
                            rel="noreferrer"
                            className={Style.app}
                          >
                            <img src={AppStore} alt="nesine-app-store" />
                            <span
                              dangerouslySetInnerHTML={{ __html: t('companiesPage.appStore') }}
                            ></span>
                          </a>
                        )}
                        {platform === 'android' && (
                          <a
                            href="https://play.google.com/store/apps/details?id=com.pordiva.nesine.android&hl=tr"
                            target="_blank"
                            rel="noreferrer"
                            className={Style.app}
                          >
                            <img src={PlayStore} alt="nesine-play-store" />
                            <span
                              dangerouslySetInnerHTML={{ __html: t('companiesPage.playStore') }}
                            ></span>
                          </a>
                        )}
                        {platform === 'huawei' && (
                          <a
                            href="https://appgallery.huawei.com/app/C102487555"
                            target="_blank"
                            rel="noreferrer"
                            className={Style.app}
                          >
                            <img src={HuaweiGallery} alt="nesine-huaweri-app-gallery" />
                            <span
                              dangerouslySetInnerHTML={{
                                __html: t('companiesPage.huaweiGallery'),
                              }}
                            ></span>
                          </a>
                        )}
                        {platform === 'other' && (
                          <>
                            <div className={Style.app}>
                              <img src={AppStore} alt="nesine-app-store" />
                              <span
                                dangerouslySetInnerHTML={{ __html: t('companiesPage.appStore') }}
                              ></span>
                            </div>
                            <div className={Style.app}>
                              <img src={PlayStore} alt="nesine-play-store" />
                              <span
                                dangerouslySetInnerHTML={{ __html: t('companiesPage.playStore') }}
                              ></span>
                            </div>
                            <div className={Style.app}>
                              <img src={HuaweiGallery} alt="nesine-huaweri-app-gallery" />
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: t('companiesPage.huaweiGallery'),
                                }}
                              ></span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className={clsx(Style.section, Style.services)}>
            <div className={Style.container}>
              <div className={Style.textWrapper}>
                <h2 className={Style.heading}>{t('companiesPage.services.title')}</h2>
                <div className={Style.servicesText}>
                  {Object.values(nesineServicesText).map((text, index) => (
                    <p key={index}>
                      <img src={NIcon} alt="nGaming-icon" />
                      <span dangerouslySetInnerHTML={{ __html: t(text) }}></span>
                    </p>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </>
      ),
    },
    {
      key: 'atyarisi',
      label: 'atyarışı.com',
      content: (
        <>
          <section className={Style.section}>
            <div className={Style.container}>
              <div className={Style.companyDetail}>
                <div className={Style.companyText}>
                  <h2 className={Style.companyName}>atyarışı.com</h2>
                  <div className={Style.companyInfo}>
                    {Object.values(atyarisiTabText).map((text, index) => (
                      <p key={index} dangerouslySetInnerHTML={{ __html: t(text) }} />
                    ))}
                  </div>
                </div>
                <div className={Style.companyAttachments}>
                  <a
                    href="https://www.atyarisi.com/hakkimizda/sirketimiz"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className={clsx(Style.logo, Style.yellowBg)}>
                      <img src={AyLogo} alt={'Atyarisi Logo'} />
                    </div>
                  </a>
                  <div className={Style.documentsWrapper}>
                    <a
                      className={Style.document}
                      href={'./assets/docs/069-4-RACE-27001-2025-Rev.00-B1.pdf'}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={DownloadIcon} alt="download-icon" />
                      {t('companiesPage.iso27001Docs')}
                    </a>
                    <a
                      className={Style.document}
                      href={'./assets/docs/AtYarisi-LogoBrand.pdf'}
                      onClick={() => {
                        dataLayerPush('ATYARIŞI');
                      }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={DownloadIcon} alt="download-icon" />
                      LOGO
                    </a>
                  </div>
                  <div className={Style.socialWrapper}>
                    <h4 className={Style.socialTitle}>{t('companiesPage.followUs')}</h4>
                    <div className={clsx(Style.linksWrapper, Style.twiceLinksWrapper)}>
                      <a
                        href="https://www.atyarisi.com"
                        className={Style.link}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={WebIcon} alt="web-icon" />
                        atyarisi.com
                      </a>
                      <a
                        href="https://www.instagram.com/atyarisicom"
                        className={Style.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={InstagramIcon} alt="instagram-icon" />
                        atyarisicom
                      </a>
                      <a
                        href="https://x.com/atyarisicom"
                        className={Style.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={XIcon} alt="x-icon" />
                        atyarisicom
                      </a>
                      <a
                        href="https://www.youtube.com/@atyarisi_com"
                        className={Style.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={YoutubeIcon} alt="youtube-icon" />
                        atyarisi_com
                      </a>
                    </div>
                  </div>
                  <div className={Style.appWrapper}>
                    <h4 className={Style.appTitle}>{t('companiesPage.downloadApps')}</h4>
                    <div className={Style.downloadOptions}>
                      <a href="https://www.atyarisi.com/indir" target="_blank" rel="noreferrer">
                        <img src={AyQR} alt="atyarisi-uygulama-indir" className={Style.qrImg} />
                      </a>
                      <div className={Style.appList}>
                        {platform === 'ios' && (
                          <a
                            href="https://apps.apple.com/tr/app/atyar%C4%B1%C5%9F%C4%B1-com-tjk-at-yar%C4%B1%C5%9F%C4%B1/id6478582534"
                            target="_blank"
                            rel="noreferrer"
                            className={Style.app}
                          >
                            <img src={AppStore} alt="nesine-app-store" />
                            <span
                              dangerouslySetInnerHTML={{ __html: t('companiesPage.appStore') }}
                            ></span>
                          </a>
                        )}
                        {platform === 'android' && (
                          <a
                            href="https://play.google.com/store/apps/details?id=com.atyarisi&hl=tr"
                            target="_blank"
                            rel="noreferrer"
                            className={Style.app}
                          >
                            <img src={PlayStore} alt="nesine-play-store" />
                            <span
                              dangerouslySetInnerHTML={{ __html: t('companiesPage.playStore') }}
                            ></span>
                          </a>
                        )}
                        {platform === 'huawei' && (
                          <a
                            href="https://appgallery.huawei.com/app/C113736353"
                            target="_blank"
                            rel="noreferrer"
                            className={Style.app}
                          >
                            <img src={HuaweiGallery} alt="nesine-huaweri-app-gallery" />
                            <span
                              dangerouslySetInnerHTML={{
                                __html: t('companiesPage.huaweiGallery'),
                              }}
                            ></span>
                          </a>
                        )}
                        {platform === 'other' && (
                          <>
                            <div className={Style.app}>
                              <img src={AppStore} alt="nesine-app-store" />
                              <span
                                dangerouslySetInnerHTML={{ __html: t('companiesPage.appStore') }}
                              ></span>
                            </div>
                            <div className={Style.app}>
                              <img src={PlayStore} alt="nesine-play-store" />
                              <span
                                dangerouslySetInnerHTML={{ __html: t('companiesPage.playStore') }}
                              ></span>
                            </div>
                            <div className={Style.app}>
                              <img src={HuaweiGallery} alt="nesine-huaweri-app-gallery" />
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: t('companiesPage.huaweiGallery'),
                                }}
                              ></span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className={clsx(Style.section, Style.services)}>
            <div className={Style.container}>
              <div className={Style.textWrapper}>
                <h2 className={Style.heading}>{t('companiesPage.services.title')}</h2>
                <div className={Style.servicesText}>
                  {Object.values(atyarisiServicesText).map((text, index) => (
                    <p key={index}>
                      <img src={AyIcon} alt="atyarisi-icon" />
                      <span dangerouslySetInnerHTML={{ __html: t(text) }}></span>
                    </p>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </>
      ),
    },
    {
      key: 'liderform',
      label: 'Liderform',
      content: (
        <section className={Style.section}>
          <div className={Style.container}>
            <div className={Style.companyDetail}>
              <div className={Style.companyText}>
                <h2 className={Style.companyName}>Liderform</h2>
                <div className={Style.companyInfo}>
                  {Object.values(liderFormTabText).map((text, index) => (
                    <p key={index} dangerouslySetInnerHTML={{ __html: t(text) }} />
                  ))}
                  <ul>
                    <p>{t('companiesPage.companies.liderformList.p1')}</p>
                    <li>{t('companiesPage.companies.liderformList.p2')}</li>
                    <li>{t('companiesPage.companies.liderformList.p3')}</li>
                    <li>{t('companiesPage.companies.liderformList.p4')}</li>
                    <li>{t('companiesPage.companies.liderformList.p5')}</li>
                  </ul>
                  <p>{t('companiesPage.companies.liderformList.p6')}</p>
                </div>
              </div>
              <div className={Style.companyAttachments}>
                <a href="https://liderform.com.tr" target="_blank" rel="noreferrer">
                  <div className={Style.logo}>
                    <img src={LiderFormLogo} alt="liderform-Logo" />
                  </div>
                </a>
                <div className={Style.documentsWrapper}>
                  <a
                    className={Style.document}
                    href={'./assets/docs/Liderform-Logo.pdf'}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => {
                      dataLayerPush('LİDERFORM');
                    }}
                  >
                    <img src={DownloadIcon} alt="download-icon" />
                    LOGO
                  </a>
                </div>
                <div className={Style.socialWrapper}>
                  <h4 className={Style.socialTitle}>{t('companiesPage.followUs')}</h4>
                  <div className={clsx(Style.linksWrapper, Style.twiceLinksWrapper)}>
                    <a
                      href="http://liderform.com.tr"
                      className={Style.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={WebIcon} alt="web-icon" />
                      liderform.com.tr
                    </a>
                    <a
                      href="https://www.instagram.com/liderform.com.tr"
                      className={Style.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={InstagramIcon} alt="instagram-icon" />
                      liderform.com.tr
                    </a>
                    <a
                      href="https://www.facebook.com/liderform"
                      className={Style.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={TiktokIcon} alt="youtube-icon" />
                      liderform
                    </a>
                    <a
                      href="https://x.com/liderformcomtr"
                      className={Style.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={XIcon} alt="x-icon" />
                      liderformcomtr
                    </a>
                  </div>
                </div>
                <div className={Style.appWrapper}>
                  <h4 className={Style.appTitle}>{t('companiesPage.downloadApps')}</h4>
                  <div className={Style.downloadOptions}>
                    <img src={LiderFormQR} className={Style.qrImg} alt="liderform-uygulama-indir" />
                    <div className={Style.appList}>
                      {platform === 'ios' && (
                        <a
                          href="https://apps.apple.com/tr/app/liderform/id1380650135?l=tr"
                          target="_blank"
                          rel="noreferrer"
                          className={Style.app}
                        >
                          <img src={AppStore} alt="nesine-app-store" />
                          <span
                            dangerouslySetInnerHTML={{ __html: t('companiesPage.appStore') }}
                          ></span>
                        </a>
                      )}
                      {platform === 'android' && (
                        <a
                          href="https://play.google.com/store/apps/details?id=com.liderform&pcampaignid=web_share"
                          target="_blank"
                          rel="noreferrer"
                          className={Style.app}
                        >
                          <img src={PlayStore} alt="nesine-play-store" />
                          <span
                            dangerouslySetInnerHTML={{ __html: t('companiesPage.playStore') }}
                          ></span>
                        </a>
                      )}
                      {platform === 'other' && (
                        <>
                          <div className={Style.app}>
                            <img src={AppStore} alt="liderform-app-store" />
                            <span
                              dangerouslySetInnerHTML={{ __html: t('companiesPage.appStore') }}
                            ></span>
                          </div>
                          <div className={Style.app}>
                            <img src={PlayStore} alt="nesine-play-store" />
                            <span
                              dangerouslySetInnerHTML={{ __html: t('companiesPage.playStore') }}
                            ></span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ),
    },
    {
      key: 'totem',
      label: 'Totem',
      content: (
        <section className={Style.section}>
          <div className={Style.container}>
            <div className={Style.companyDetail}>
              <div className={Style.companyText}>
                <h2 className={Style.companyName}>Totem</h2>
                <div className={Style.companyInfo}>
                  <p dangerouslySetInnerHTML={{ __html: t('companiesPage.companies.totem.p1') }} />
                </div>
              </div>
              <div className={Style.companyAttachments}>
                <div className={clsx(Style.logo, Style.yellowBg)}>
                  <img src={TotemLogo} alt="totem-Logo" />
                </div>
                <div className={Style.documentsWrapper}>
                  <a
                    className={Style.document}
                    href={'./assets/docs/totem-Logo.pdf'}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => {
                      dataLayerPush('TOTEM');
                    }}
                  >
                    <img src={DownloadIcon} alt="download-icon" />
                    LOGO
                  </a>
                </div>
                <div className={Style.socialWrapper}>
                  <h4 className={Style.socialTitle}>{t('companiesPage.followUs')}</h4>
                  <div className={Style.linksWrapper}>
                    <a
                      href="https://www.instagram.com/totemtayfa"
                      className={Style.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={InstagramIcon} alt="instagram-icon" />
                      totemtayfa
                    </a>
                    <a
                      href="https://x.com/totemtayfa"
                      className={Style.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={XIcon} alt="x-icon" />
                      totemtayfa
                    </a>
                    <a
                      href="https://www.tiktok.com/@totemtayfa"
                      className={Style.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={TiktokIcon} alt="youtube-icon" />
                      totemtayfa
                    </a>
                    <a
                      href="https://www.youtube.com/@TotemTayfa"
                      className={Style.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={YoutubeIcon} alt="youtube-icon" />
                      TotemTayfa
                    </a>
                    <a
                      href="https://www.facebook.com/profile.php?id=61558736436189"
                      className={Style.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={FacebookIcon} alt="youtube-icon" />
                      TotemTayfa
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ),
    },
  ];

  return (
    <>
      <SEO pageKey="companies" />
      <PageHeader title={t('companiesTitle')} />
      <div className={Style.sectionCompanies}>
        <div className={Style.container}>
          <Tabs tabs={tabs} defaultActiveKey="nesine" />
        </div>
      </div>
    </>
  );
};

export default Companies;
